const defaultState = {
  user: {},
  authState: null,
  authUser: null,
  tasks: [],
};

export default defaultState;
